import type { OrderStatus } from '../types/OrderStatus';

export const OrderStatuses: { [K in OrderStatus]: K } = {
    NEW: 'NEW',
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    WAIT_FOR_CONFIRMATION: 'WAIT_FOR_CONFIRMATION',
    WAIT_FOR_DELIVERY: 'WAIT_FOR_DELIVERY',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
};
